import { CommonModule } from '@angular/common';
import { Component, EventEmitter, NgModule, Output } from '@angular/core';

@Component({
  selector: 'ngx-mat-file-input',
  template: `
    <input
      type="file"
      [attr.accept]="accept || null"
      [attr.multiple]="multiple ? '' : null"
      (change)="onNativeChange($event)"
      [disabled]="disabled"
    />
  `,
  standalone: false
})
export class FileInputComponent {
  accept?: string;
  multiple?: boolean;
  disabled = false;

  @Output() change = new EventEmitter<Event>();

  onNativeChange(event: Event): void {
    this.change.emit(event);
  }
}

@NgModule({
  declarations: [FileInputComponent],
  imports: [CommonModule],
  exports: [FileInputComponent]
})
export class MaterialFileInputModule {}
